import classes from './SubHeader.module.css'

export default function SubHeader({ children }) {
  return <div className={classes.subheader}>{children}</div>
}
